import Banner from "../../images/banner.jpg";
import "./Refunds.css";
import Footer from "../Footer/Footer";
import NavBar from "../Layout/NavBar";

const Refunds = () => {
  const year = new Date().getFullYear();

  return (
    <div className="refunds-home">
      {/* Banner */}
      <div className="refunds-banner">
        <img src={Banner} alt="Refunds Banner" />
      </div>

      <NavBar />

      <div className="refunds-container">
        <h1>Refund & Returns Policy</h1>
        <p className="updated-date">Last updated: {year}</p>

        <section>
          <h2>Overview</h2>
          <p>
            We want you to be satisfied with your purchase from Flickerbound.
            This Refund & Returns Policy explains how returns, refunds, and
            replacements are handled for both physical and digital products.
          </p>
        </section>

        <section>
          <h2>Physical Products</h2>
          <p>
            Returns for physical items (such as journals or coloring books) are
            accepted within <strong>30 days</strong> of delivery.
          </p>
          <p>To qualify for a return:</p>
          <ul>
            <li>The item must be unused</li>
            <li>The item must be in its original condition</li>
            <li>Packaging should be intact when possible</li>
          </ul>
          <p>
            Once your return is received and inspected, we will notify you of
            approval or rejection. Approved returns will be refunded to your
            original payment method.
          </p>
        </section>

        <section>
          <h2>Digital Products</h2>
          <p>
            Due to the nature of digital goods, refunds are not guaranteed.
            However, we may offer refunds on a case‑by‑case basis if:
          </p>
          <ul>
            <li>You received the wrong digital file</li>
            <li>The file is corrupted or unusable</li>
            <li>A technical issue prevented access</li>
          </ul>
          <p>
            If you experience an issue with a digital product, please contact us
            and we will work with you to resolve it.
          </p>
        </section>

        <section>
          <h2>Damaged or Defective Items</h2>
          <p>
            If your physical item arrives damaged, please contact us within{" "}
            <strong>7 days</strong> of delivery. We will provide a replacement or
            refund depending on the situation.
          </p>
        </section>

        <section>
          <h2>Non‑Returnable Items</h2>
          <p>The following items cannot be returned:</p>
          <ul>
            <li>Digital downloads</li>
            <li>Gift cards</li>
            <li>Items marked as final sale</li>
          </ul>
        </section>

        <section>
          <h2>Late or Missing Refunds</h2>
          <p>
            If you haven’t received a refund yet, please check with your bank or
            card provider. Processing times vary. If you still have concerns,
            reach out to us for assistance.
          </p>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>If you have questions about this Refund Policy, you can reach us at:</p>
          <p>
            <strong>https://flickerbound.com/contact</strong>
          </p>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default Refunds;
